module.exports = __webpack_public_path__ + "static/media/lend_win.30796b7a.svg";